document.addEventListener('DOMContentLoaded', function() {
  initLooxRatingFormatting();
  initReadMoreToggles();
  initProduct();
  initAddToCartPriceSync();
  initSubscriptionGiftSync();
});

function formatLooxRatingLabels() {
  const labels = document.querySelectorAll('.shopify-app-block .loox-rating-label');

  labels.forEach((label) => {
    // Skip if already processed
    if (label.dataset.formatted === 'true') return;

    const text = label.textContent.trim();
    // Match the leading number, e.g. "4.8" in "4.8 from 5 Reviews"
    const match = text.match(/^(\d+(?:\.\d+)?)(.*)$/);
    if (!match) return;

    const [, rating, rest] = match;
    const formattedRating = rating.replace('.', ',');

    // Replace "review"/"reviews" (any case) with "Dog Owners"
    const formattedRest = rest.replace(/reviews?/gi, 'Dog Owners');

    label.innerHTML = `&nbsp;<strong>${formattedRating}</strong>${formattedRest}`;
    label.dataset.formatted = 'true';
  });
}

// Loox injects its markup async, so poll/observe until labels appear and have text
function initLooxRatingFormatting() {
  const observer = new MutationObserver(() => {
    formatLooxRatingLabels();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  // Also run once immediately in case it's already there
  formatLooxRatingLabels();
}

function initReadMoreToggles(selector) {
  selector = selector || 'a[href="#read_more"]';

  document.querySelectorAll(selector).forEach(function (link) {
    var wrapper = link.closest('p');
    if (!wrapper) return;

    // Find the first text node in the <p> containing the '||' marker
    var textNode = Array.prototype.find.call(wrapper.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE && node.textContent.indexOf('||') !== -1;
    });
    if (!textNode) return; // no marker found, nothing to do

    var parts = textNode.textContent.split('||');
    var visiblePart = parts[0];
    var hiddenPart = parts.slice(1).join('||'); // in case '||' appears more than once

    var dotsSpan = document.createElement('span');
    dotsSpan.className = 'read-more-dots';
    dotsSpan.textContent = '....';

    var hiddenSpan = document.createElement('span');
    hiddenSpan.className = 'read-more-content';
    hiddenSpan.style.display = 'none';
    hiddenSpan.textContent = hiddenPart;

    var fragment = document.createDocumentFragment();
    fragment.appendChild(document.createTextNode(visiblePart));
    fragment.appendChild(dotsSpan);
    fragment.appendChild(hiddenSpan);

    wrapper.replaceChild(fragment, textNode);

    link.addEventListener('click', function (e) {
      e.preventDefault();
      var expanded = hiddenSpan.style.display !== 'none';
      hiddenSpan.style.display = expanded ? 'none' : 'inline';
      dotsSpan.style.display = expanded ? 'inline' : 'none';

      var label = link.querySelector('strong') || link;
      label.textContent = expanded ? 'See More...' : 'See Less';
    });
  });
}

function initProduct() {
  if (!document.querySelector('#MainContent').getAttribute('data-template').includes('product')) return;

  document.querySelectorAll('variant-picker[data-product-id]').forEach(function (variantPicker) {
    var productId = variantPicker.dataset.productId;
    if (!productId) return;

    var formComponent = document.querySelector('product-form-component[data-product-id="' + productId + '"]');
    if (!formComponent) return;

    var sellingPlanInput = formComponent.querySelector('[name="selling_plan"]');
    if (!sellingPlanInput) return;

    var tabs = variantPicker.querySelectorAll('.custom-product-variant-tab');
    var planFieldset = variantPicker.querySelector('[data-option="choose-options"]');

    // If your plan-count option doesn't handleize to "choose-options", update the selector
    // above (and the data-option value in variant-picker.liquid) to match, or this will
    // silently find nothing.
    if (!planFieldset) return;

    // Purchase Options (Flexible Plan / One time purchase) is a static client-side tab, NOT a
    // real Shopify option - every variant has its own selling plan allocation attached
    // regardless of which tab is active, so subscription-vs-one-time is determined ENTIRELY
    // by tab state, not by anything on the variant itself.
    var currentTabName = 'flexible-plan';

    function getActiveTabName() {
      var activeTab = variantPicker.querySelector('.custom-product-variant-tab.active');
      return activeTab ? activeTab.dataset.tabName : 'one-time';
    }

    function getSelectedSellingPlanId() {
      var checked = planFieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.dataset.sellingPlanId || '' : '';
    }

    function syncSellingPlanInput() {
      var isFlexible = getActiveTabName() === 'flexible-plan';
      var sellingPlanId = getSelectedSellingPlanId();
      sellingPlanInput.value = isFlexible && sellingPlanId ? sellingPlanId : '';
    }

    // Toggles which pricing block is visible per option (variant-picker.liquid renders both
    // a "flexible-plan" block - with the plan name and selling-plan price - and a "one-time"
    // block - variant price only, no plan name - for every option value). This is purely a
    // visual swap; syncSellingPlanInput() above is what actually controls what gets submitted.
    function syncPlanDetailsVisibility() {
      var isFlexible = getActiveTabName() === 'flexible-plan';
      planFieldset.querySelectorAll('[data-purchase-option]').forEach(function (el) {
        var isMatch = el.dataset.purchaseOption === (isFlexible ? 'flexible-plan' : 'one-time');
        el.classList.toggle('hidden', !isMatch);
      });
    }

    // Dispatches on document (not on variantPicker) so anything on the page can listen
    // without needing a reference to this component. This fires synchronously on tab click -
    // there's no fetch involved anymore, since Purchase Options isn't a real variant change -
    // so anything listening (e.g. variant-unlocks.liquid) gets the correct state instantly,
    // with no async race to guard against.
    function dispatchPurchaseOptionChange() {
      var isSubscription = !!sellingPlanInput.value;
      document.dispatchEvent(
        new CustomEvent('purchase-option:change', {
          bubbles: true,
          detail: {
            isSubscription: isSubscription,
            isOneTime: !isSubscription,
            sellingPlanId: sellingPlanInput.value || null,
            productId: productId,
          },
        })
      );
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        currentTabName = tab.dataset.tabName;
        tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('active', isActive);
          t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        syncSellingPlanInput();
        syncPlanDetailsVisibility();
        dispatchPurchaseOptionChange();
      });
    });

    // Native radio change events fire regardless of any other component listening, so this
    // stays correct even if the theme's own variant-picker JS also reacts to the same click.
    planFieldset.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"]')) {
        syncSellingPlanInput();
        dispatchPurchaseOptionChange();
      }
    });

    // Disable the add-to-cart button(s) the moment a new TINCTURE COUNT is selected
    // (variant:selected fires synchronously, before variant-picker.js's fetch even starts),
    // and re-enable once the resolved variant actually lands (variant:update, after the
    // fetch/morph completes). Purchase Options tab clicks don't need this - they're pure
    // client-side, no fetch involved, so there's no gap to guard against there.
    var pendingEnableTimeout = null;

    function setAddToCartButtonsDisabled(disabled) {
      formComponent.querySelectorAll('add-to-cart-component').forEach(function (addToCartComponent) {
        if (disabled && typeof addToCartComponent.disable === 'function') {
          addToCartComponent.disable();
        } else if (!disabled && typeof addToCartComponent.enable === 'function') {
          addToCartComponent.enable();
        }
      });
    }

    variantPicker.addEventListener('variant:selected', function () {
      setAddToCartButtonsDisabled(true);
      if (pendingEnableTimeout) clearTimeout(pendingEnableTimeout);
      // Failsafe: variant-picker.js's fetch can fail without dispatching anything (its catch
      // block only logs, it doesn't fire an event on non-abort errors), which would otherwise
      // leave the button disabled indefinitely.
      pendingEnableTimeout = setTimeout(function () {
        setAddToCartButtonsDisabled(false);
      }, 8000);
    });

    // When a different TINCTURE COUNT is selected, variant-picker.js fetches and morphs
    // fresh server HTML into the fieldset - which always has "Flexible Plan" marked active
    // and its price block visible by default, with no awareness of which tab was actually
    // selected. Re-apply the real selection (and re-sync everything that depends on it)
    // right after that morph lands.
    document.addEventListener('variant:update', function (event) {
      var eventProductId = event.detail && event.detail.data && event.detail.data.productId;
      if (eventProductId && String(eventProductId) !== String(productId)) return;

      tabs.forEach(function (t) {
        var isActive = t.dataset.tabName === currentTabName;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      syncSellingPlanInput();
      syncPlanDetailsVisibility();
      dispatchPurchaseOptionChange();

      if (pendingEnableTimeout) {
        clearTimeout(pendingEnableTimeout);
        pendingEnableTimeout = null;
      }
      setAddToCartButtonsDisabled(false);
    });

        // Default to "2 Tinctures" (2nd variant option) on first page load. Doesn't override a
    // deep link - if the URL already specifies a variant, that's respected.
    //
    // The radios aren't guaranteed to exist yet at this point - if variant-picker is still
    // rendering/hydrating (slow connection, other scripts delaying it, etc.) a one-shot
    // querySelectorAll can miss the target entirely. So: try immediately, and if that fails,
    // watch the fieldset for radios being added and retry, bounded by a timeout so we don't
    // observe forever if something goes wrong.
    var hasVariantParam = new URL(window.location.href).searchParams.has('variant');

    function findDefaultTarget() {
      return Array.from(planFieldset.querySelectorAll('input[type="radio"]')).find(function (input) {
        var label = input.getAttribute('aria-label') || '';
        return label.indexOf('2 Tinctures') === 0;
      });
    }

    function applyDefaultSelection() {
      var target = findDefaultTarget();
      if (!target) return false;

      if (!target.checked) {
        // Fires 'change', which triggers syncSellingPlanInput/dispatchPurchaseOptionChange
        // via the planFieldset change listener registered above.
        target.click();
      } else {
        // Already checked (e.g. server rendered it that way) - no 'change' event will fire
        // from a click we didn't make, so sync state manually.
        syncSellingPlanInput();
      }
      syncPlanDetailsVisibility();
      return true;
    }

    if (hasVariantParam) {
      syncSellingPlanInput();
      syncPlanDetailsVisibility();
    } else if (!applyDefaultSelection()) {
      var defaultObserverTimeout;
      var defaultObserver = new MutationObserver(function () {
        if (applyDefaultSelection()) {
          defaultObserver.disconnect();
          clearTimeout(defaultObserverTimeout);
        }
      });
      defaultObserver.observe(planFieldset, { childList: true, subtree: true });

      // Safety net: stop watching after 8s either way, so a fieldset that never gets its
      // radios (unexpected markup issue, etc.) doesn't leave an observer running forever.
      defaultObserverTimeout = setTimeout(function () {
        defaultObserver.disconnect();
        syncSellingPlanInput();
        syncPlanDetailsVisibility();
      }, 8000);
    }
  });
}

/**
 * Keeps the add-to-cart button's price in sync with the selected tincture-count variant AND
 * which Purchase Options tab (Flexible Plan / One time purchase) is active.
 *
 * Purchase Options is a static client-side tab now, not a real Shopify option - so the server
 * has no way to reflect it in the add-to-cart button's rendered price. This computes it
 * locally instead, from the same variant price map already used elsewhere (each variant's
 * own price/compareAtPrice/sellingPlans), combined with reading which tab is currently active.
 */
function initAddToCartPriceSync() {
  if (!document.querySelector('#MainContent').getAttribute('data-template').includes('product')) return;

  document.querySelectorAll('variant-picker[data-product-id]').forEach(function (variantPickerAtInit) {
    var productId = variantPickerAtInit.dataset.productId;
    if (!productId) return;

    var mapScript = variantPickerAtInit.querySelector('script[data-variant-price-map]');
    if (!mapScript) return;

    var variantPriceMap;
    try {
      variantPriceMap = JSON.parse(mapScript.textContent);
    } catch (error) {
      console.error('Failed to parse variant price map:', error);
      return;
    }

    function getVariantPicker() {
      return document.querySelector('variant-picker[data-product-id="' + productId + '"]');
    }

    function getFormComponent() {
      return document.querySelector('product-form-component[data-product-id="' + productId + '"]');
    }

    function getActiveTabName() {
      var variantPicker = getVariantPicker();
      var activeTab = variantPicker && variantPicker.querySelector('.custom-product-variant-tab.active');
      return activeTab ? activeTab.dataset.tabName : 'one-time';
    }

    function getSelectedVariantId() {
      var variantPicker = getVariantPicker();
      if (!variantPicker) return null;
      var scope = variantPicker.querySelector('[data-option="choose-options"]') || variantPicker;
      var checkedRadio = scope.querySelector('input[type="radio"]:checked');
      if (checkedRadio && checkedRadio.dataset.variantId) {
        return checkedRadio.dataset.variantId;
      }
      var selectedOption = scope.querySelector('select option:checked, select option[selected]');
      if (selectedOption && selectedOption.dataset.variantId) {
        return selectedOption.dataset.variantId;
      }
      return null;
    }

    function updatePrice() {
      var formComponent = getFormComponent();
      var priceEl = formComponent && formComponent.querySelector('[ref="addToCartPrice"]');
      if (!priceEl) return;

      var variantId = getSelectedVariantId();
      if (!variantId) return;

      var variant = variantPriceMap.find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (!variant) return;

      var isFlexible = getActiveTabName() === 'flexible-plan';
      var hasSellingPlan = variant.sellingPlans && variant.sellingPlans.length > 0;

      var priceText =
        isFlexible && hasSellingPlan ? variant.sellingPlans[0].priceFormatted : variant.priceFormatted;

      priceEl.textContent = priceText;
    }

    updatePrice();

    // Delegated listeners on document (not on captured element references) so they keep
    // working even if variant-picker.js's morph replaces the fieldsets with new nodes.
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('variant-picker[data-product-id="' + productId + '"]')) {
        updatePrice();
      }
    });

    document.addEventListener('click', function (event) {
      var tab = event.target && event.target.closest && event.target.closest('.custom-product-variant-tab');
      if (tab && tab.closest('variant-picker[data-product-id="' + productId + '"]')) {
        updatePrice();
      }
    });

    // Re-run after product-form.js's variant:update morph replaces the button (fires on
    // tincture-count changes), so the tab-aware price always wins over the server's
    // tab-blind version. Scoped to this product via the event's own productId.
    document.addEventListener('variant:update', function (event) {
      var eventProductId = event.detail && event.detail.data && event.detail.data.productId;
      if (eventProductId && String(eventProductId) !== String(productId)) return;
      updatePrice();
    });
  });
}

/**
 * variant-unlocks.js
 *
 * Keeps subscription-tier gift line items in sync with the cart, driven entirely by
 * `window.subscriptionGiftUnlocks` (rendered from Theme Settings > Subscription gift
 * unlocks - see snippets/gift-unlock-map.liquid). No dependency on any specific product
 * page: this listens globally, so it works from the cart drawer, cart page, or anywhere
 * else the cart can change.
 *
 * window.subscriptionGiftUnlocks shape:
 *   [
 *     {
 *       variantId: "123456789",
 *       requiresSubscription: true,
 *       gifts: [ { variantId: "111", quantity: 1 }, ... ]
 *     },
 *     ...
 *   ]
 *
 * A cart line "qualifies" a group when its variant_id matches that group's variantId,
 * and (if requiresSubscription is true) the line has a selling_plan_allocation - i.e. it
 * was actually purchased as a subscription, not a one-time purchase of the same variant.
 *
 * Every gift line THIS script adds is tagged with a hidden line-item property
 * (_subscription_gift: 'true' - Shopify hides underscore-prefixed properties from the
 * customer-facing cart/checkout automatically). Only lines carrying that tag are ever
 * adjusted or removed, so a customer manually buying the same product used as a gift is
 * never touched.
 *
 * No progress bar / visual sync indicator - gifts are just silently added/removed.
 */
function initSubscriptionGiftSync() {
  if (typeof window.subscriptionGiftUnlocks === 'undefined') {
    console.warn('initSubscriptionGiftSync: window.subscriptionGiftUnlocks is not defined - is gift-unlock-map.liquid rendered in theme.liquid?');
    return;
  }

  var config = window.subscriptionGiftUnlocks;
  if (!Array.isArray(config) || config.length === 0) return;

  var GIFT_PROPERTY_KEY = '_subscription_gift';
  var syncing = false;

  /**
   * Finds the config group matching a cart line's variant, if that line currently
   * qualifies (subscription requirement met when applicable).
   * @param {Object} item - A /cart.js line item.
   * @returns {Object|null}
   */
  function getQualifyingGroup(item) {
    var group = null;
    for (var i = 0; i < config.length; i++) {
      if (String(config[i].variantId) === String(item.variant_id)) {
        group = config[i];
        break;
      }
    }
    if (!group) return null;

    var hasSellingPlan = !!item.selling_plan_allocation;
    if (group.requiresSubscription && !hasSellingPlan) return null;

    return group;
  }

  /**
   * @param {Object} cart - A /cart.js response.
   * @returns {Map<string, number>} Required gift variant id -> quantity.
   */
  function computeRequiredGifts(cart) {
    var required = new Map();

    cart.items.forEach(function (item) {
      var group = getQualifyingGroup(item);
      if (!group || !group.gifts) return;

      group.gifts.forEach(function (gift) {
        var id = String(gift.variantId);
        // Gift quantity is fixed per the configured group - it does NOT scale with how
        // many units of the subscription line itself were purchased.
        var qty = Number(gift.quantity) || 1;
        // If more than one qualifying group grants the same gift variant (e.g. two
        // different subscription products in the same cart both unlock it), use whichever
        // configured quantity is larger rather than summing them.
        var existing = required.get(id) || 0;
        required.set(id, Math.max(existing, qty));
      });
    });

    return required;
  }

  /**
   * @param {Object} cart - A /cart.js response.
   * @returns {Object[]} Line items previously added by this script.
   */
  function getControlledLines(cart) {
    return cart.items.filter(function (item) {
      return item.properties && item.properties[GIFT_PROPERTY_KEY] === 'true';
    });
  }

  /**
   * Reconciles required gifts against what's actually in the cart, and applies changes.
   * @param {Object} cart - A /cart.js response.
   */
  async function syncGifts(cart) {
    if (syncing || !cart || !cart.items) return;

    var required = computeRequiredGifts(cart);
    var controlledLines = getControlledLines(cart);

    var controlledByVariant = new Map();
    controlledLines.forEach(function (item) {
      controlledByVariant.set(String(item.variant_id), item);
    });

    /** @type {Array<{id: string, quantity: number, properties: Object}>} */
    var toAdd = [];
    /** @type {Record<string, number>} */
    var toUpdate = {};

    required.forEach(function (qty, variantId) {
      var existingLine = controlledByVariant.get(variantId);
      if (!existingLine) {
        toAdd.push({ id: variantId, quantity: qty, properties: (function () {
          var props = {};
          props[GIFT_PROPERTY_KEY] = 'true';
          return props;
        })() });
      } else if (existingLine.quantity !== qty) {
        toUpdate[existingLine.key] = qty;
      }
    });

    controlledLines.forEach(function (item) {
      if (!required.has(String(item.variant_id))) {
        toUpdate[item.key] = 0;
      }
    });

    if (toAdd.length === 0 && Object.keys(toUpdate).length === 0) return;

    syncing = true;

    try {
      if (Object.keys(toUpdate).length > 0) {
        var updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: toUpdate }),
        });
        if (!updateResponse.ok) throw new Error('Gift update failed: ' + updateResponse.status);
      }

      if (toAdd.length > 0) {
        var addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: toAdd }),
        });
        if (!addResponse.ok) throw new Error('Gift add failed: ' + addResponse.status);
      }

      // Tell the rest of the cart UI to refresh now that gifts have been reconciled.
      // This does not itself trigger cart:update/cart:updated, so it won't loop back here.
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { reason: 'subscription-gift-sync' } }));
    } catch (error) {
      console.error('Subscription gift sync failed:', error);
    } finally {
      syncing = false;
    }
  }

  async function fetchCartAndSync() {
    try {
      var response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart fetch failed: ' + response.status);
      var cart = await response.json();
      await syncGifts(cart);
    } catch (error) {
      console.error('Failed to fetch cart for subscription gift sync:', error);
    }
  }

  /**
   * Handles both cart:update (native theme event, detail.resource) and cart:updated
   * (custom event some flows use, detail.cart) - whichever one fires.
   * @param {CustomEvent<{resource?: Object, cart?: Object}>} event
   */
  function handleCartEvent(event) {
    var cart = (event.detail && (event.detail.resource || event.detail.cart)) || null;
    if (cart) {
      syncGifts(cart);
    } else {
      // Event fired without a usable cart payload (e.g. an error state) - fetch fresh.
      fetchCartAndSync();
    }
  }

  // cart:update covers add-to-cart, quantity changes, and line removal alike - all three
  // go through the same CartAddEvent/CartUpdateEvent dispatch in this theme. cart:updated
  // is listened for too in case that custom event wiring is present.
  document.addEventListener('cart:update', handleCartEvent);
  document.addEventListener('cart:updated', handleCartEvent);

  // Initial sync on page load, in case the cart's current gift state doesn't match what
  // the config now says it should be (e.g. settings changed since the cart was built, or
  // the cart was modified elsewhere like the /cart page or another tab).
  fetchCartAndSync();
}